import React, { PureComponent } from 'react';
import axios from 'axios';
import { Form, Input, Button, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import { cw, hp } from "../../utils";

import AuthHeader from './Header';


class InvitationSignIn extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            visaMomoModalVisible: false, bankModalVisible: false,
            currency: '', modalFooterImages: [],
            token: window.location.pathname.split('/')[3],
            accountId: props._utils.inv_accountId,
        };
    }

    _signin = e => {
        e.preventDefault();
        const { form: { validateFields }, signIn, intl, _utils: { lang, inv_account, inv_email } } = this.props;
        validateFields((err, vals) => {
            if (!err) {
                signIn(intl, lang, { email: vals.email.trim(), password: vals.password }, (data) => {
                    axios({
                        method: 'POST',
                        url: `${hp.getApiBaseUrl()}/invitations/${this.state.token}/user-confirmations`,
                        json: true,
                        data: {
                            email: inv_email
                            // accountId: this.state.accountId,
                            // userId: data.user.id,
                            // invitationId: this.state.token
                        }
                    }).then((res) => {
                        if (res.data.statusCode === 200) {
                            axios({
                                method: 'POST',
                                url: `${hp.getApiBaseUrl()}/auth/account-logins`,
                                headers: { 'x-access-token': hp.getCookie('user_token') },
                                data: {
                                    accountId: res.data.data.account.id,
                                    userId: res.data.data.user.id
                                }
                            }).then((response) => {
                                const res = response.data;
                                if (res.statusCode === 200) {
                                    hp.setCookie('user_token', res.token);
                                    hp.setCookie('project_id', inv_account.id);
                                    hp.setCookie('active_account', JSON.stringify(inv_account));
                                    window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                                } else {
                                    notification.error({ message: this.props.intl.formatMessage(cw['Error.Default']) });
                                }
                            }).catch(() => {
                                notification.error({ message: this.props.intl.formatMessage(cw['Error.Default']) });
                            });
                        } else {
                            notification.error({
                                message: this.props.intl.formatMessage(cw['Failed']),
                                description: this.props.intl.formatMessage(cw['JoinOrganisation.Failed'])
                            });
                        }
                    }).catch((err) => {
                        notification.success({
                            message: this.props.intl.formatMessage(cw['Failed']),
                            description: this.props.intl.formatMessage(cw['JoinOrganisation.Failed'])
                        });
                    });
                });
            }
        });
    };

    render() {
        const { form: { getFieldDecorator, getFieldValue }, _auth: { signingIn }, _utils: { inv_email } } = this.props;

        return (
            <React.Fragment>
                <Form id="esoko__signin" autoComplete="off" hideRequiredMark onSubmit={this._signin}>
                    <AuthHeader screen="signin" />
                    <p><b><FormattedMessage id="Invite.Signin.InfoText" defaultMessage="Sign in to complete the process of joining this organization." /></b></p>

                    <Form.Item required={true} colon={false} label={<FormattedMessage id="Label.EmailAddress" defaultMessage="Email Address" />}>
                        {getFieldDecorator('email', {
                            rules: [
                                { required: true, message: <FormattedMessage id="Rules.EmailAddress.Required" defaultMessage="Please provide email address" /> },
                            ],
                            initialValue: inv_email
                        })(
                            <Input autoFocus autoComplete="off" size="large" disabled placeholder="you@domain.com" sso-id="login-username" />
                        )}
                    </Form.Item>
                    <Form.Item required={true} colon={false} label={<FormattedMessage id="Label.Password" defaultMessage="Password" />}>
                        {getFieldDecorator('password', {
                            rules: [
                                { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                            ]
                        })(
                            <Input.Password autoComplete="off" size="large" type="password" placeholder={this.props.intl.formatMessage(cw['Placeholder.Password'])} sso-id="login-password" />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Button className="submitBtn" block size="large" type="primary" htmlType="submit" disabled={!getFieldValue('email') && !getFieldValue('password')} loading={signingIn} sso-id="login-button">
                            <FormattedMessage id="Button.Signin" defaultMessage="Sign in" />
                        </Button>
                    </Form.Item>
                </Form>
            </React.Fragment>
        );
    }
}

const InvitationSignInForm = Form.create()(InvitationSignIn);
export default InvitationSignInForm;